import { RefreshCw, KeyRound, Monitor } from 'lucide-react';

export const productGroups = [
  {
    id: 'recharge',
    number: '01',
    audience: '已有账号，升级订阅',
    delivery: '卡密 + 充值地址',
    title: '代充值',
    description: '自己的账号，找大师兄帮你快速升级。账号始终在你手上。',
    Icon: RefreshCw,
    accent: 'orange',
    products: [
      { id: 1, productId: 243, name: 'ChatGPT Plus', variant: '', tagline: '日常对话、写作、办公', price: 20.5, priceRMB: 139, originalPrice: 24.9, originalPriceRMB: 168, method: '自助充值', icon: '↗', description: '付款后自动收到卡密和充值地址，按步骤完成升级。', tags: ['保留原账号', '无需账密'], fulfillment: 'self' },
      { id: 2, productId: 367, name: 'ChatGPT Pro', variant: '5X', tagline: '独享 Pro，约 5 倍额度', price: 117.5, priceRMB: 799, originalPrice: 132, originalPriceRMB: 899, method: '自助充值', icon: '↗', description: '适合高频使用者，额度更充足，升级后立即生效。', tags: ['保留原账号', '额度升级'], fulfillment: 'self' },
      { id: 3, productId: 369, name: 'ChatGPT Pro', variant: '20X', tagline: '独享 Pro，约 20 倍额度', price: 190.9, priceRMB: 1299, originalPrice: 220, originalPriceRMB: 1499, method: '自助充值', icon: '↗', description: '旗舰额度方案，适合重度创作和专业工作流。', tags: ['保留原账号', '旗舰额度'], fulfillment: 'self' },
    ],
  },
  {
    id: 'account',
    number: '02',
    audience: '需要一个全新账号',
    delivery: '新账号 + 升级卡密',
    title: '成品号',
    description: '提供全新账号和升级卡密，登录后按步骤自助激活。',
    Icon: KeyRound,
    accent: 'ink',
    products: [
      { id: 4, productId: 314, name: 'ChatGPT Plus', variant: '', tagline: '全新账号 · Plus 订阅', price: 20.5, priceRMB: 139, originalPrice: 24.9, originalPriceRMB: 168, method: '全新成品号', icon: '＋', description: '全新 Plus 账号，未绑定手机号，收到后自助激活。', tags: ['全新账号', '自助激活'], fulfillment: 'account', accountFeeRMB: 10 },
      { id: 5, productId: 368, name: 'ChatGPT Pro', variant: '5X', tagline: 'Pro 5X 成品号', price: 117.5, priceRMB: 799, originalPrice: 132, originalPriceRMB: 899, method: '全新成品号', icon: '＋', description: '全新独享 Pro 账号，适合高频办公与创作。', tags: ['独享 Pro', '快速交付'], fulfillment: 'account', accountFeeRMB: 10 },
    ],
  },
  {
    id: 'shared',
    number: '03',
    audience: '想通过网页使用 AI',
    delivery: '网页访问入口',
    title: '网页共享版',
    description: '无需账号密码，通过专属网页直接使用 AI，轻量又省心。',
    Icon: Monitor,
    accent: 'sand',
    products: [
      { id: 7, productId: 252, available: false, name: 'ChatGPT Plus', variant: '网页共享', tagline: '网页端专属入口 · 按月使用', price: 4.9, priceRMB: 49, method: '网页共享版', icon: '↗', description: '付款后发放专属访问入口，对话记录独立保存。', tags: ['无需账密', '网页直达'], fulfillment: 'web-shared' },
      { id: 8, productId: 258, name: 'GPT + Claude Max', includesClaude: true, available: false, variant: '网页共享', tagline: 'ChatGPT Plus + Claude Max · 一站使用', price: 8.2, priceRMB: 99, method: '网页共享版', icon: '↗', description: '一个网页入口同时使用 GPT 与 Claude Max，适合需要多模型协作的用户。', tags: ['GPT + Claude', '无需账密'], fulfillment: 'web-shared' },
    ],
  },
];

export function createCheckoutProduct(product, group) {
  const accountFeeRMB = product.accountFeeRMB || 0;
  return {
    ...product,
    name: `${product.name}${product.variant ? ` ${product.variant}` : ''} ${product.method}`,
    priceRMB: product.priceRMB + accountFeeRMB,
    basePriceRMB: product.priceRMB,
    accountFeeRMB,
    duration: '1个月',
    color: group.accent,
  };
}

export function findCheckoutProduct(productId) {
  for (const group of productGroups) {
    const product = group.products.find((item) => String(item.productId) === String(productId));
    if (product) return createCheckoutProduct(product, group);
  }
  return null;
}
